import { type RouteObject } from 'react-router'

import { lazyDefault } from 'routes/lazy-route'

export const projectHomeRoutes: RouteObject[] = [
  {
    index: true,
    lazy: lazyDefault(() => import('features/project-home/Container')),
  },
]
